
const About = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-black via-blue-950 to-blue-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          {/* Section Header */}
          <div className="mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-8">
              <i className="ri-lightbulb-line text-2xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              About StartupCoin
            </h2>
            <div className="w-24 h-1 bg-white mx-auto"></div>
          </div>

          {/* Main Content */}
          <div className="space-y-8 text-lg md:text-xl text-white/90 leading-relaxed">
            <p className="font-light">
              StartupCoin is a crypto-community that helps people bring their dreams to life — 
              whether it's launching a startup, an art project, or a personal goal.
            </p>
            
            <p className="font-light">
              By holding and using the <span className="text-blue-300 font-semibold">$Startup</span> token, 
              members can vote for, fund, and support real-world projects submitted by dreamers around the world.
            </p>
          </div>

          {/* Mission Statement */}
          <div className="mt-16 p-8 bg-white/5 rounded-2xl border border-white/10">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-6">
              Our Mission
            </h3>
            <p className="text-xl text-blue-200 font-light leading-relaxed">
              Empower dreamers to turn their ideas into reality, one project at a time — 
              powered by the people, not the system.
            </p>
          </div>

          {/* Key Features */}
          <div className="mt-16 grid md:grid-cols-3 gap-8">
            <div className="text-center group">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6 group-hover:bg-white/20 transition-all duration-300">
                <i className="ri-community-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-semibold text-white mb-4">
                Community-Driven
              </h4>
              <p className="text-white/80 font-light">
                A movement where crypto meets purpose
              </p>
            </div>

            <div className="text-center group">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6 group-hover:bg-white/20 transition-all duration-300">
                <i className="ri-eye-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-semibold text-white mb-4">
                Transparent
              </h4>
              <p className="text-white/80 font-light">
                Every decision made by the community
              </p>
            </div>

            <div className="text-center group">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6 group-hover:bg-white/20 transition-all duration-300">
                <i className="ri-heart-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-semibold text-white mb-4">
                Purposeful
              </h4>
              <p className="text-white/80 font-light">
                Every coin helps someone achieve their dream
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
